export interface SkillWithCategory {
  skillKey: string;
  category: string;
}

export class AllCVOptionsFromDB {
  genders?: Array<string>;
  languages?: Array<string>;
  languageLevels?: Array<string>;
  skills?: Array<SkillWithCategory>;
  skillLevels?: Array<string>;
  benefits?: Array<string>;
  educationLevels?: Array<{ id: number; educationKey: string; sortOrder: number }>;
}

export class ParseCvPersonalInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dob: string;
  address: string;
  city: string;
  houseNumber: string;
}
